import PropTypes from 'prop-types';
import { MODULES, USER_TYPES } from 'react/signups/card/recipes/constants';

const recipeShape = PropTypes.shape({
  name: PropTypes.oneOf(Object.values(MODULES)).isRequired,
  modulePath: PropTypes.string.isRequired,
  defaultPath: PropTypes.string.isRequired,
  variants: PropTypes.shape({
    [USER_TYPES.CLIENT]: PropTypes.shape({
      sequence: PropTypes.arrayOf(PropTypes.string).isRequired,
      next: PropTypes.string.isRequired,
    }),
    [USER_TYPES.FAMILY]: PropTypes.shape({
      sequence: PropTypes.arrayOf(PropTypes.string).isRequired,
      next: PropTypes.string.isRequired,
    }),
    [USER_TYPES.MYSELF]: PropTypes.shape({
      sequence: PropTypes.arrayOf(PropTypes.string).isRequired,
      next: PropTypes.string.isRequired,
    }),
  }).isRequired,
});

export default recipeShape;
